import { lazy } from 'react';
import { RoutePath } from '../../../../shared/types/routePaths';

const AdminProfile = lazy(
  () => import('../../../../pages/AdminProfile/AdminProfile'),
);
const Cart = lazy(() => import('../../../../pages/Cart/Cart'));
const Catalog = lazy(() => import('../../../../pages/Catalog'));
const Login = lazy(() => import('../../../../pages/Login/Login'));
const Register = lazy(() => import('../../../../pages/Register/Register'));
const ItemPage = lazy(() => import('../../../../pages/ItemPage/ItemPage'));
const Home = lazy(() => import('../../../../pages/Home'));
const Checkout = lazy(() => import('../../../../pages/Checkout/Checkout'));
const CheckoutSuccessfulPage = lazy(
  () =>
    import('../../../../pages/CheckoutSuccessful/ui/CheckoutSuccessfulPage/CheckoutSuccessfulPage'),
);
const NotFound = lazy(() => import('../../../../pages/NotFound/NotFound'));
const Contacts = lazy(() => import('../../../../pages/Contacts/Contacts'));
const UserProfile = lazy(
  () => import('../../../../pages/UserProfile/UserProfile'),
);
const Leathers = lazy(() => import('../../../../pages/Leathers/Leathers'));

interface Routes {
  path: RoutePath;
  Component: React.FC;
}

export const adminRoutes: Routes[] = [
  { path: RoutePath.ADMIN_PROFILE, Component: AdminProfile },
];
export const userRoutes: Routes[] = [
  { path: RoutePath.USER_PROFILE, Component: UserProfile },
  { path: RoutePath.CHECKOUT, Component: Checkout },
  { path: RoutePath.CHECKOUT_SUCCESSFUL, Component: CheckoutSuccessfulPage },
];

export const publicRoutes: Routes[] = [
  { path: RoutePath.CART, Component: Cart },
  {
    path: RoutePath.CATALOG,
    Component: Catalog,
  },
  {
    path: RoutePath.LOGIN,
    Component: Login,
  },
  {
    path: RoutePath.REGISTRATION,
    Component: Register,
  },
  {
    path: RoutePath.ITEM_PAGE,
    Component: ItemPage,
  },
  {
    path: RoutePath.HOME,
    Component: Home,
  },
  {
    path: RoutePath.CONTACTS,
    Component: Contacts,
  },
  {
    path: RoutePath.NOT_FOUND,
    Component: NotFound,
  },
  {
    path: RoutePath.LEATHERS,
    Component: Leathers,
  },
];
